import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import merge from 'lodash/merge';
import { useCallback, useMemo } from 'react';
import { FilterBase } from '@/utils/widget/createSelections/interfaces';
import { chartColorPallet as DEFAULT_COLORS } from '@/config/colorPallets/universalDesignSystem';
import { useTheme } from '@/components/widget/Layout/ThemeProvider';
import { getResultExampleValue } from '@/components/Editor/Form/utils';
import useSelections from '@/components/widget/misc/useSelections';
import useSubscribeWidgetResults from '@/components/widget/visualizations/hooks/useSubscribeWidgetResults';
import * as LineChartCollectionOption from '@/components/Editor/Form/LineChartFields/CollectionOption';
import * as RadarChartCollectionOption from '@/components/Editor/Form/RadarChartFields/CollectionOption';
import * as PointChartCollectionOption from '@/components/Editor/Form/PointChartFields/CollectionOption';
import * as BarChartCollectionOption from '@/components/Editor/Form/barChart/BarChartFields/CollectionOption';
import * as StackedBarChartCollectionOption from '@/components/Editor/Form/barChart/StackedBarChartFields/CollectionOption';
import styles from './styles.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DEFAULT_SELECTION_CONFIG = {
  base: FilterBase.Pairs
};
export const COMPONENT_CONFIG_MAP = {
  LineChart: LineChartCollectionOption.generateCollectionSettings,
  RadarChart: RadarChartCollectionOption.generateCollectionSettings,
  BarChart: BarChartCollectionOption.generateCollectionSettings,
  StackedBarChart: StackedBarChartCollectionOption.generateCollectionSettings,
  Bubble: PointChartCollectionOption.generateCollectionSettings,
  Scatter: PointChartCollectionOption.generateCollectionSettings
};
const COMPONENT_OPTIONS_MAP = {
  LineChart: LineChartCollectionOption,
  RadarChart: RadarChartCollectionOption,
  BarChart: BarChartCollectionOption,
  StackedBarChart: StackedBarChartCollectionOption,
  Bubble: PointChartCollectionOption,
  Scatter: PointChartCollectionOption
};

const EditSectionCollection = _ref => {
  var _COMPONENT_OPTIONS_MA;

  let {
    sectionComponent,
    collectionIndex,
    widgetId,
    sectionId,
    reportingWidgetId,
    config,
    variant,
    onChange
  } = _ref;
  const {
    colorPallet: defaultColorPallet = DEFAULT_COLORS,
    theme,
    styles: themeStyles
  } = useTheme();
  const CurrentComponent = (_COMPONENT_OPTIONS_MA = COMPONENT_OPTIONS_MAP[sectionComponent]) === null || _COMPONENT_OPTIONS_MA === void 0 ? void 0 : _COMPONENT_OPTIONS_MA.default;
  const {
    colorPallet = defaultColorPallet,
    collectionOptions
  } = config;
  const collectionOption = useMemo(() => (collectionOptions || [])[collectionIndex] || {}, [collectionOptions, collectionIndex]); // Get component specific configuration

  const collectionConfig = useMemo(() => {
    const generateConfig = COMPONENT_CONFIG_MAP[sectionComponent];
    if (typeof generateConfig !== 'function') return null;
    return generateConfig({
      theme: theme.id,
      themeStyles,
      config,
      component: sectionComponent,
      collectionOption,
      collectionIndex,
      colorPallet
    });
  }, [sectionComponent, theme, themeStyles, config, collectionOption, collectionIndex, colorPallet]); // Get current selection results

  const results = useSubscribeWidgetResults(reportingWidgetId); // Apply selections to results

  const {
    selectionResults
  } = useSelections({
    results: results,
    selections: config.selections || '',
    selectionsLabeled: (collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.selectionsLabeled) ?? false,
    selectionConfig: (collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.selectionConfig) ?? DEFAULT_SELECTION_CONFIG
  }); // Defaults to integer as example
  // value for template authoring

  const exampleValue = useMemo(() => getResultExampleValue({
    collectionIndex,
    selectionIndex: 0,
    valueIndex: 1,
    spreadsheetSelections: selectionResults,
    fallback: 10
  }), [selectionResults, collectionIndex]);
  const handleChange = useCallback(function (update) {
    let attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const baseChange = !attr ? {
      selections: ''
    } : {};
    onChange(`collectionOptions.${collectionIndex}${attr ? '.' : ''}${attr}`, merge({}, update, baseChange));
  }, [onChange, collectionIndex]);

  if (!CurrentComponent) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(styles.heading, styles[`heading--${variant}`]),
      children: [(collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.title) ?? 'Group', " ", collectionIndex + 1]
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.content, styles[`content--${variant}`]),
      children: /*#__PURE__*/_jsx(CurrentComponent, _objectSpread(_objectSpread({
        nameSpace: `${widgetId}-${sectionId}-${collectionIndex}`,
        collectionIndex: collectionIndex,
        collectionOption: collectionOption,
        colorPallet: colorPallet,
        exampleValue: exampleValue,
        defaults: collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.defaults
      }, collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.defaultProps), {}, {
        onChange: handleChange
      }))
    })]
  });
};

export default EditSectionCollection;